import moment from 'moment'

// 'YYYY-MM-DD HH:mm:ss' to ISO moment
export const isoDate = (string) => {
    return string ? moment(string.replace(/\s/, 'T')) : null
}